<template>
  <div>
    <v-data-table
      @dblclick:row="showTransferRow"
      :items="transfers"
      :headers="headers"
      :loading="isLoading"
      :items-per-page="30"
      :no-data-text="$t('transfer.noData')"
      :loading-text="$t('appointment.table.loading')"
      class="clickable hideSelectAll"
      mobile-breakpoint="20"
      hide-default-footer
      disable-sort
    >
      <template v-slot:[`item.host`]="{ item }">
        {{ getNames(item) }}
      </template>
      <template v-slot:[`item.receiver_type`]="{ item }">
        {{ receiverType(item) }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{ formatDate(item.created_at) }}
        </span>
        <span v-else>---</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="transferStatus(item).color" small>
          {{ transferStatus(item).status }}
        </v-chip>
      </template>
      <template v-slot:[`item.total`]="{ item }">
        <span v-if="item.total">
          {{ formatMoney(item.total) }}
        </span>
        <span v-else>---</span>
      </template>
      <template v-slot:[`item.asaas_transfer_id`]="{ item }">
        <v-chip v-if="item.asaas_transfer_id" small>
          {{ item.asaas_transfer_id }}
          <CopyToClipboard :value="item.asaas_transfer_id" />
        </v-chip>
        <span v-else>---</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="showTransfer(item.id)"
              class="mx-1"
              icon
            >
              <v-icon small>
                mdi-eye-outline
              </v-icon>
            </v-btn>
          </template>
          <span class="body-2">
            {{ $t('transfer.label.visualize') }}
          </span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-divider />

    <h-pagination :fetch="fetchTransfers" :requireOrderByFilter="false" noBorders />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { transferHeaders } from '../adminInvoiceHeaders'
import { handleColors } from '@/util/colors'

import CopyToClipboard from '@/components/app/CopyToClipboard'

export default {
  name: 'AdminTransfersInvoices',

  components: {
    CopyToClipboard,
  },

  computed: {
    ...mapGetters(['transfers', 'isLoading']),
  },

  methods: {
    ...mapMutations(['openModal']),
    ...mapActions(['fetchTransfers', 'retryTransfer']),

    showTransfer(id) {
      window.open(`/transfer/${id}`)
    },

    showTransferRow(_, { item }) {
      this.showTransfer(item.id)
    },

    getNames(item) {
      switch(item?.receiver_type) {
        case('HOST'):
          return item?.host?.name
        case('VENDOR'):
          return item?.vendor?.name
        case('PARTNER'):
          return item?.partner?.name
        default:
          return '---'
      }
    },

    receiverType(item) {
      return item.receiver_type ? this.$t(`transfer.receiverType.${item.receiver_type}`) : '---'
    },

    transferStatus(item) {
      return {
        color: handleColors(item.status),
        status: this.$t(`transfer.transferStatus.${item.status}`),
      }
    }
  },

  data() {
    return {
      headers: transferHeaders,
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
      selectedTransfers: [],
      parsedTransfers: [],
    }
  },
}
</script>
